import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api/client';

export const SPV_FIELDS = [
  ['name', 'Name', 'text'], ['cin', 'CIN', 'text'], ['deal_type', 'Deal type', 'select:acquire_sell,development'],
  ['share_price', 'Share price (₹)', 'number'], ['shares_offered', 'Shares offered', 'number'],
  ['min_shares', 'Minimum shares', 'number'], ['max_investors', 'Maximum investors', 'number'],
  ['promoter_members', 'Promoter members', 'number'], ['target_capital', 'Target capital (₹)', 'number'],
  ['escrow_account_ref', 'Escrow account reference', 'text'],
  ['exit_fee_pct', 'Exit fee % (acquire & sell)', 'number'], ['carry_pct', 'Carry % (development)', 'number'],
  ['hurdle_pct', 'Hurdle % (development)', 'number'], ['resale_buyer_pct', 'Resale buyer %', 'number'],
  ['resale_seller_pct', 'Resale seller %', 'number'], ['referral_pct', 'Referral %', 'number'],
  ['description', 'Description', 'textarea'],
];

export const fieldInput = (type, value, onChange, name) => {
  if (type.startsWith('select:')) {
    return (
      <select id={name} value={value} onChange={onChange} className="select">
        <option value="">Choose…</option>
        {type.slice(7).split(',').map((o) => <option key={o} value={o}>{o.replace('_', ' ')}</option>)}
      </select>
    );
  }
  if (type === 'textarea') return <textarea id={name} value={value} onChange={onChange} rows={3} className="input" />;
  return <input id={name} type={type} step={type === 'number' ? 'any' : undefined} value={value} onChange={onChange} className="input" />;
};

export const apiError = (e) => {
  const d = e.response?.data;
  if (!d) return 'Request failed';
  if (typeof d === 'string') return d;
  if (d.detail) return d.detail;
  const [k, v] = Object.entries(d)[0] || [];
  return k ? `${k}: ${Array.isArray(v) ? v[0] : v}` : 'Request failed';
};

const AdminSpvs = () => {
  const [spvs, setSpvs] = useState(null);
  const [form, setForm] = useState({ name: '', deal_type: 'development' });
  const navigate = useNavigate();

  const load = useCallback(() => api.get('/api/admin/spvs/').then((r) => setSpvs(r.data)).catch(() => toast.error('Failed to load SPVs')), []);
  useEffect(() => { load(); }, [load]);

  const create = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/api/admin/spvs/', form);
      toast.success('SPV created as a draft');
      navigate(`/admin/spvs/${res.data.id}`);
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const required = SPV_FIELDS.filter(([n]) => ['name', 'deal_type', 'share_price', 'shares_offered', 'min_shares', 'max_investors', 'target_capital'].includes(n));
  return (
    <main style={{ maxWidth: 900, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>SPVs</h1>
      {!spvs ? <p>Loading…</p> : (
        <table style={{ width: '100%' }}>
          <thead><tr><th align="left">Name</th><th align="left">Type</th><th align="left">Status</th><th align="right">Shares</th><th align="right">Price</th></tr></thead>
          <tbody>{spvs.map((s) => (
            <tr key={s.id}><td><Link to={`/admin/spvs/${s.id}`}>{s.name}</Link></td><td>{s.deal_type.replace('_', ' ')}</td><td>{s.status}</td>
              <td align="right">{s.shares_offered}</td><td align="right">₹{Number(s.share_price).toLocaleString('en-IN')}</td></tr>
          ))}</tbody>
        </table>
      )}
      <h2>New SPV</h2>
      <form onSubmit={create} style={{ display: 'grid', gap: 8, maxWidth: 480 }}>
        {required.map(([n, label, type]) => (
          <label key={n} htmlFor={n}>{label}{fieldInput(type, form[n] ?? '', (e) => setForm({ ...form, [n]: e.target.value }), n)}</label>
        ))}
        <p>Fee rates default to the standard terms and can be changed on the next screen.</p>
        <button type="submit">Create draft</button>
      </form>
    </main>
  );
};

export default AdminSpvs;
